import type zh from '../zh/tasks';

/**
 * Frozen copy of the tasks text the UI showed before the zh/en switch, rendered while
 * UI_I18N_ENABLED is off (gamma / prod). Do not edit the text; add a key here only when
 * zh gains one, with the text the UI would show without the switch. Delete with the flag.
 */
const tasks: typeof zh = {
  page: {
    title: 'Task',
    scheduledTab: 'Scheduled Tasks',
    historyTab: 'Execution History',
  },
  /** BCP 47 locale for dates and times on this page (today it is always en-US). */
  dateLocale: 'en-US',
  scheduled: {
    title: 'Scheduled Tasks',
    description: 'Cron 任务管理 · 查看调度、执行历史和运行结果',
    loading: 'Loading tasks...',
    loadFailed: 'Failed to load tasks',
    errorTitle: 'Error loading tasks',
    emptyTitle: 'No scheduled tasks',
    emptyBody: 'No tasks have been created yet.',
    filterEmptyTitle: 'No tasks',
    filterEmptyBody: 'No scheduled tasks found.',
    noMatchTitle: 'No matches',
    noMatchBody: 'No tasks match the filter.',
    filterPlaceholder: 'Find resources',
    matches: '{{n}} matches',
    hint: '通过右手边的对话框，你可以用自然语言创建和管理定时任务。告诉我「做什么、什么时候、做几次」即可。试试这样说：',
    hintIcon: 'Info',
    example1: '"每周一早上 9 点给我发一份和我客户相关的新闻并说明对我 pipeline 的影响"',
    example2: '"每周二早上 10 点给我发一封邮件告知我 Top10 客户的 revenue 和 pipeline 进度"',
    example3: '"每天早上通过 Slack 提醒我需要 follow up 的 pipeline"',
    example4: '"帮我取消每天 Sales Daily Brief 的发送"',
  },
  columns: {
    name: '任务名称',
    payload: 'Payload',
    schedule: '调度',
    nextRun: '下次运行',
    lastRun: '上次运行',
    status: '状态',
    taskId: 'Task ID',
  },
  status: {
    scheduled: '正常',
    completed: '已完成',
    invokeFailed: '调用失败',
  },
  preferences: {
    title: 'Preferences',
    confirm: 'Confirm',
    cancel: 'Cancel',
    pageSize: 'Page size',
    pageSizeOption: '{{n}} items',
    visibleColumns: 'Visible columns',
    taskProperties: 'Task properties',
    wrapLines: 'Wrap lines',
    wrapLinesDescription: 'Wrap long lines in table cells',
    stripedRows: 'Striped rows',
    stripedRowsDescription: 'Alternate row shading',
  },
  history: {
    title: 'Execution History',
    loadFailed: 'Failed to load execution history',
    last7: 'Last 7 Days',
    last30: 'Last 30 Days',
    last90: 'Last 90 Days',
    statusAll: 'Status: All',
    statusSuccess: 'Success',
    statusFailed: 'Failed',
    statusRunning: 'Running',
    contentTypeAll: 'Content Type',
    emptyTitle: 'No execution records',
    emptyBody: 'No executions found for the selected filters.',
    // Count labels mirror today's `n > 1` rule (zh has one plural form, so i18next plurals cannot express it).
    itemsOne: '{{n}} Item',
    itemsMany: '{{n}} Items',
    errorsDetected: '({{n}} Error Detected)',
    taskId: 'Task ID: {{id}}',
    time: 'Time: {{time}}',
    contentType: 'Content Type: {{type}}',
    timeUsed: 'Time Used: {{duration}}',
    itemSuccess: 'Success',
    itemError: 'Error',
    itemRunning: 'Running',
  },
};

export default tasks;
